import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Wallet } from "lucide-react";
import { useCotiPluginContext } from "@/context/PrivacyBridgeContext";

interface ConnectWalletGuardProps {
    children: ReactNode;
    title?: string;
    description?: string;
}

const ConnectWalletGuard = ({
    children,
    title = "Wallet Not Connected",
    description = "Connect your wallet to continue."
}: ConnectWalletGuardProps) => {
    const { isConnected, handleConnect } = useCotiPluginContext();

    if (isConnected) {
        return <>{children}</>;
    }

    return (
        <div className="flex-1 flex items-center justify-center px-4">
            <div className="glass-card p-8 max-w-md w-full text-center">
                <div className="w-20 h-20 rounded-full bg-warning/20 border-2 border-warning/50 flex items-center justify-center mx-auto mb-6">
                    <Wallet className="h-10 w-10 text-warning" />
                </div>

                <h2 className="text-2xl font-bold text-foreground mb-2">{title}</h2>
                <p className="text-sm text-muted-foreground mb-8">
                    {description}
                </p>

                <Button variant="default" className="w-full bg-primary hover:bg-primary/90" onClick={handleConnect}>
                    Connect Wallet
                </Button>
            </div>
        </div>
    );
};

export default ConnectWalletGuard;
